import { insertMentionNode } from '#pplx/frontend/apps/ask/ask-input/ask-input-mentions/insertMentionNode.js';
import { useCallback, useMemo } from 'react';
export function useAskInputSpaces({ lexicalEditorRef, onBeforeSpaceMentionInsert, }) {
    const onSpaceSelect = useCallback((space) => {
        const editor = lexicalEditorRef?.current;
        if (!editor) {
            return;
        }
        onBeforeSpaceMentionInsert?.(space);
        insertMentionNode(editor, {
            uuid: space.uuid,
            variant: space.variant,
            text: space.label,
            url: space.url,
            icon: space.icon,
            queryText: space.queryText,
        });
    }, [lexicalEditorRef, onBeforeSpaceMentionInsert]);
    return useMemo(() => (lexicalEditorRef ? { onSpaceSelect } : {}), [lexicalEditorRef, onSpaceSelect]);
}
//# sourceMappingURL=useAskInputSpaces.js.map